import React from 'react'
import '../../src/assets/AdminCss/Menu.css'
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const Menu = () => {
    const navigate= useNavigate();



    return (
        <div className='container-fluid px-3 bg-white'>

            <div className='d-flex justify-content-between mt-3'><span className=' text-center border-warning rounded' onClick={()=> navigate(-1)}><i className="fas fa-arrow-left"></i></span>
             {/* <span><img src='/assets/images/KheloyarnetLogo.svg' alt='logo' style={{height:'37px'}}/></span> */}
             </div>

            <div className='d-flex justify-content-around my-5 '>
                <div className='border pdd text-center rounded' onClick={()=>navigate('/')} >
                    <img src='/menu/home.png' alt='tablegames' />Home
                </div>
                <div className='border pdd text-center rounded' onClick={()=>navigate('/inplayMatches')} >
                    <img src='/menu/inplay.png' alt='tablegames' />Inplay
                </div>
                <div className='border pdd text-center rounded' onClick={()=>toast.success('coming soon')}>
                    <img src='/menu/exchange.png' alt='tablegames' />Exchange
                </div>
                <div className='border pdd text-center rounded' onClick={()=>navigate('/sportAll')} >
                    <img src='/menu/sportsbook.png' alt='tablegames' />Sports Book
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Casinos</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:7}})}><img src='/menu/livecasino.png' alt='tablegames'/> Live Casino</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:18}})}><img src='/menu/tablegames.png' alt='tablegames'/>Table Games</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:5}})}><img src='/menu/indian.png' alt='tablegames'/>Indian Casino</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:16}})}><img src='/menu/slotgames.png' alt='tablegames'/>Slot Games</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/populargames.png' alt='tablegames'/>Popular Games</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:14}})}><img src='/menu/lottery.png' alt='tablegames'/>Lottery</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:19}})}><img src='/menu/shooting.png' alt='tablegames'/>Shooting Games</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:11}})}><img src='/menu/crashgames.png' alt='tablegames'/>Crash Games</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:13}})}><img src='/menu/lightning.png' alt='tablegames'/>Lightning</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:15}})}><img src='/menu/blackjack.png' alt='tablegames'/>Black Jack</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames')}><img src='/menu/allcasino.png' alt='tablegames'/>All Casino</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:21}})}><img src='/menu/scratch.png' alt='tablegames' />Scratch games</div>
                    
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Multiplayer</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:5}})}><img src='/menu/rummy.png' alt='tablegames' />Rummy</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:6}})}><img src='/menu/ludo.png' alt='tablegames' />Ludo</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/teenpatti.png' alt='tablegames' />Teen Patti</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:6}})}><img src='/menu/multiplayer.png' alt='tablegames' />All Multiplayer</div>                    
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Sports</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'onClick={()=>navigate('/cricketreal')} ><img src='/menu/cricket.png' alt='tablegames'/>Cricket</div>
                    <div className='border rounded pdd' onClick={()=>navigate('/footballreal')} ><img src='/menu/soccer.png' alt='tablegames'/>Soccer</div>
                    <div className='border rounded pdd'  onClick={() => navigate("/tennisreal")} ><img src='/menu/tennis.png' alt='tablegames'/>Tennis</div>
                    <div className='border rounded pdd' onClick={()=>toast.success("coming soon !")} ><img src='/menu/horseracing.png' alt='tablegames'/>Horse Racing</div>
                    <div className='border rounded pdd'onClick={()=>toast.success("coming soon !")} ><img src='/menu/greyhound.png' alt='tablegames'/>Greyhound</div>                  
                    <div className='border rounded pdd' onClick={()=>toast.success("coming soon !")} ><img src='/menu/rugby.png' alt='tablegames'/>Rugby</div>
                    <div className='border rounded pdd' onClick={() => navigate("/sportAll")}><img src='/menu/sportsbook.png' alt='tablegames'/>Sports Book</div>
                    <div className='border rounded pdd'onClick={()=>navigate("/virtual")} ><img src='/menu/virtualsports.png' alt='tablegames' />Virtual Sports</div>

                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>ESports</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'><img src='/menu/strike.png' alt='tablegames' />Counter Strike</div>
                    <div className='border rounded pdd'><img src='/menu/callofduty.png' alt='tablegames' />Call of Duty</div>
                    <div className='border rounded pdd'><img src='/menu/data2.png' alt='tablegames' />Data 2</div>
                    <div className='border rounded pdd'><img src='/menu/allsports.png' alt='tablegames' />All ESports</div>                    
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Popular Games</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:11}})}><img src='/menu/aviator.png' alt='tablegames' />Aviator</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames')}><img src='/menu/bigballer.png' alt='tablegames' />Big Baller</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/crazytime.png' alt='tablegames' />Crazy Time</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:9}})}><img src='/menu/rouletteevo.png' alt='tablegames' />Roulette EVO</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:9}})}><img src='/menu/roulette.png' alt='tablegames' />Roulette</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/dragontiger.png' alt='tablegames' />Dragon Tiger</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/andarbahar.png' alt='tablegames' />Andar Bahar</div>

                    <div className='border rounded pdd' onClick={()=>navigate('/casinoGames',{state:{list:4}})}><img src='/menu/patti20.png' alt='tablegames' />Teen Patti 20</div> 
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Providers</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'><img src='/menu/evolution.png' alt='tablegames' />Evolution</div>
                    <div className='border rounded pdd'><img src='/menu/mac88.png' alt='tablegames' />Macc88</div>
                    <div className='border rounded pdd'><img src='/menu/qtech.png' alt='tablegames' />QTech</div>
                    <div className='border rounded pdd'><img src='/menu/providers.png' alt='tablegames' />All Providers</div>                    
                </div>
            </div>

            <div className='border border-warning rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Accessibility</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'><img src='/menu/blackjack.png' alt='tablegames'/>My Markets</div>
                    <div className='border rounded pdd'><img src='/menu/withdraw.webp' alt='tablegames'/>Withdraw</div>
                    <div className='border rounded pdd'><img src='/menu/support.webp' alt='tablegames'/>Support</div>
                    <div className='border rounded pdd'><img src='/menu/setting.svg' alt='tablegames'/>Settings</div>                    
                </div>
            </div>

            <button className='btn bg-yellow w-100 mb-5'>Download App</button>
            
        </div>
    )
}

export default Menu